<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col cols="auto">
            <b-button id="table-settings" size="sm" variant="warning" class="mr-2" v-b-toggle.sidebar-fields>
              <font-awesome-icon icon="cog"/>
            </b-button>
            <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
              Колонки
            </b-tooltip>
            <b-btn v-if="canEditLocationVacancies()" size="sm" variant="success" :disabled="isBusy" @click="showModal(null, false)">
              <b-spinner v-if="isBusy" small/>
              <font-awesome-icon icon="plus" class="mr-1"/>
              Новая
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <filters-drawer
      :query.sync="filters.query"
      :is-busy="isBusy"
      :filter-tags="activeFilterTags"
      @remove-tag="removeFilterTag"
      @submit="onSearch"
      @clear="onClearFilters"
    >
      <b-col cols="12">
        <label class="small text-muted">Шаблоны вакансий</label>
        <vacancy-multi-select
          id="vacancy_multi_select"
          class="mb-1"
          ref="vacancy_multi_select"
          @onSelect="onSelectVacancy"
        />
      </b-col>
      <b-col cols="12" class="mt-1">
        <label class="small text-muted">Объекты</label>
        <location-multi-select
          id="location-multi-select"
          ref="location_multi_select"
          @onSelect="onSelectLocation"
        />
      </b-col>
    </filters-drawer>

    <b-table
      id="recruit-location-vacancies"
      ref="recruit_location_vacancies"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowDblClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"/>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(action)="row">
        <b-dropdown size="sm" no-caret>
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v"/>
          </template>

          <b-dropdown-item-button v-if="canEditLocationVacancies()" variant="primary" @click.stop="showModal(row.item.id, false)">
            <font-awesome-icon icon="edit"/>
            Редактировать
          </b-dropdown-item-button>

          <b-dropdown-item-button variant="success" @click.stop="showModal(row.item.id, true)">
            <font-awesome-icon icon="eye"/>
            Смотреть
          </b-dropdown-item-button>

          <b-dropdown-item-button v-if="canEditLocationVacancies()" variant="danger" @click="onRemove(row)">
            <font-awesome-icon icon="trash"/>
            Удалить
          </b-dropdown-item-button>

        </b-dropdown>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <DynamicTables
      storage-key="recruitLocationVacancies_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      fieldKey="id"
    />

    <RecruitLocationVacancy ref="recruit_location_vacancy" @refresh="getItems" @modal-closed="onModalClosed"/>

  </div>
</template>

<script>
import locationVacancies from "../../network/locationVacancies";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
  import permissions, {PERM} from "../../utilites/permissions";
    import LocationMultiSelect from "../Locations/LocationMultiSelect.vue";
    import UserMultiSelect from "../Users/UserMultiSelect.vue";
    import VacancyMultiSelect from "../Catalogs/Vacancies/VacancyMultiSelect.vue";
    import RecruitLocationVacancy from "./RecruitLocationVacancy.vue";

export default {
  name: "RecruitLocationVacancies",
  components: { RecruitLocationVacancy, PaginationFooter, FiltersDrawer, UserMultiSelect, LocationMultiSelect, DynamicTables, VacancyMultiSelect },
  mixins: [
    locationVacancies, catalogs,
    helpers, dateFormatter, pageSearchService, permissions,
  ],
  data() {
    return {
      title: 'Шаблоны вакансий',
      items: [],
      fields: [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          visible: true,
          class: 'recruitLocationVacancyId'
        },
        {
          key: 'vacancy_name',
          label: 'Вакансия',
          sortable: true,
          visible: true,
        },
        {
          key: 'workers_count',
          label: 'Количество',
          sortable: true,
          visible: true,
        },
        {
          key: 'location_name',
          label: 'Объект',
          sortable: true,
          visible: true,
        },
      ],
      serviceEndField: {
        key: 'action',
        label: 'Действия',
        class: 'recruitLocationVacancyAction',
      },
      sortBy: 'id',
      sortDesc: true,
      isBusy: false,
      filters: this.getDefaultFilters(),
      deleteRow: {
        id: null,
        vacancy_name: '',
      },
    }
  },
  async mounted() {
    await this.configureRefs();
  },
  async created() {
    this.isBusy = true;
    const query = this.$route.query;

    if (query) {
      if (query.query) {
        this.filters.query = query.query;
      }

      if (query.locations) {
        const decodeLoc = decodeURIComponent(query.locations);
        this.filters.locations = decodeLoc.split(",");
      }

      if (query.vacancies) {
        const decodeLoc = decodeURIComponent(query.vacancies);
        this.filters.vacancies = decodeLoc.split(",");
      }
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [...this.visibleFields, this.serviceEndField];
    },
    activeFilterTags() {
      const tags = [];

      if (this.filters.locations.length > 0) {
        tags.push({ key: 'location', label: `Объекты: ${this.filters.locations.length}`});
      }

      if (this.filters.vacancies.length > 0) {
        tags.push({ key: 'vacancy', label: `Вакансии: ${this.filters.vacancies.length}`,});
      }

      return tags;
    }
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        this.$nextTick(() => {
          if (newId && this.$refs.recruit_location_vacancy) {
            const isViewonly = this.$route.query.mode === 'view';
            const vacancyData = this.items.find(item => item.id === newId);

            if (vacancyData) {
              this.$refs.recruit_location_vacancy.showModal(
                newId,
                isViewonly,
                vacancyData.location_id,
                vacancyData.location_name
              );
            } else {
              this.$refs.recruit_location_vacancy.showModal(newId, isViewonly);
            }
          } else if (!newId && this.$refs.recruit_location_vacancy) {
            this.$refs.recruit_location_vacancy.hideModal();
          }
        });
      },
      immediate: true
    },
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        locations: this.filters.locations,
        vacancies: this.filters.vacancies,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      }

      this.isBusy = true;
      const result = await this.getLocationVacancies(data);

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
      this.isBusy = false;
    },
    onRowDblClicked(item) {
      this.showModal(item.id, false);
    },
    showModal(locationVacancyId, isViewonly) {
      const canEdit = this.canEditLocationVacancies();

      if (!locationVacancyId) {
        if (!canEdit) return;

        this.$refs.recruit_location_vacancy.showModal(null, false);
        return;
      }

      const isView = isViewonly || !canEdit;
      const query = isView ? { mode: 'view' } : {};

      this.$router.push({
        name: 'RecruitLocationVacancies',
        params: { id: locationVacancyId },
        query: query
      });
    },
    onModalClosed() {
      if (this.$route.params.id) {
        this.$router.replace({
          name: 'RecruitLocationVacancies',
          params: { id: null },
          hash: this.$route.hash,
        }).catch(()=>{});
      }
    },
    onRemove(row) {
      if (!this.canEditLocationVacancies()) return;

      if (row.item) {
        this.deleteRow = row.item
      }

      const title = "Удаление шаблона вакансии";
      const message = `Вы действительно хотите удалить шаблон "${this.deleteRow.vacancy_name}"?`;
      this.showModalDelete(title, message, async () => {
        const result = await this.deleteLocationVacancy(this.deleteRow);

        if (result.error) {
          this.showToast('Ошибка при удалении.', 'Ошибка', 'danger');
        } else {
          this.showToast('Вакансия удалена.', 'Успех', 'success');
        }

        await this.getItems();
      });
    },
    // Filters
    getDefaultFilters() {
      return {
        query: '',
        locations: [],
        vacancies: [],
      };
    },
    removeFilterTag(tag) {
      if (tag.key === 'location') {
        this.filters.locations = [];
        this.$refs.location_multi_select.onClearSelected();
      }
      else if (tag.key === 'vacancy') {
        this.filters.vacancies = [];
        this.$refs.vacancy_multi_select.onClearSelected();
      }

      this.onSearch();
    },
    async onClearFilters() {
      const filters = this.getDefaultFilters();

      if (JSON.stringify(this.filters) === JSON.stringify(filters)) return;

      this.filters = filters;
      await this.configureRefs();

      await this.onSearch();
    },
    async configureRefs() {
      if (this.$refs.location_multi_select != null) {
        await this.$refs.location_multi_select.configure(this.filters.locations);
      }

      if (this.$refs.vacancy_multi_select != null) {
        await this.$refs.vacancy_multi_select.configure(this.filters.vacancies);
      }
    },
    onSelectLocation(locations) {
      this.filters.locations = locations.map(item => { return item.id; });
    },
    onSelectVacancy(vacancies) {
      this.filters.vacancies = vacancies.map(item => { return item.id; });
    },
    // Permissions
    canEditLocationVacancies() {
      return this.hasPermission([PERM.LOCATION_VACANCY_EDIT]);
    },
  },
}
</script>

<style>

.recruitLocationVacancyId {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.recruitLocationVacancyAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}

#recruit-location-vacancies td {
  vertical-align: middle;
}

</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitLocationVacancies.vue